import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { MARKETING_STARTER_ACCESS_OVERRIDE } from 'automation-ui-flow-core/validation/FlowValidationErrorTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValidationErrorAlert = ({
  actionId,
  actionName,
  onClickAlert
}) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
  message: "automation.contextualEmbed.validationErrorBanner.actionName_jsx",
  elements: {
    ActionConfigLink: ({
      children
    }) => /*#__PURE__*/_jsx(UILink, {
      onClick: () => onClickAlert(actionId),
      children: children
    }),
    strong: ({
      children
    }) => /*#__PURE__*/_jsx("strong", {
      children: children
    })
  },
  options: {
    actionName
  }
}, actionId);
const ContextualValidationErrorBanner = ({
  alerts,
  getActionName,
  onClickAlert
}) => /*#__PURE__*/_jsx(UIAlert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation.contextualEmbed.validationErrorBanner.titleText"
  }),
  type: "danger",
  children: /*#__PURE__*/_jsx(UIAccordionItem, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.contextualEmbed.validationErrorBanner.accordionTitle",
      options: {
        count: alerts.size
      }
    }),
    children: /*#__PURE__*/_jsx(UIList, {
      children: alerts.map(alert => {
        const {
          actionId,
          flowValidationErrorType
        } = alert;
        const actionName = getActionName({
          actionId: actionId,
          useString: true
        });
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [flowValidationErrorType === MARKETING_STARTER_ACCESS_OVERRIDE && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.contextualEmbed.validationErrorBanner.pleaseDelete"
            }), ' ']
          }), /*#__PURE__*/_jsx(ValidationErrorAlert, {
            actionId: actionId,
            actionName: actionName,
            onClickAlert: onClickAlert
          }, actionId)]
        });
      })
    })
  })
});
export default ContextualValidationErrorBanner;